import * as React from 'react';

const SvgWalletSafew = (props) => (
  <svg
    x={0}
    y={0}
    xmlSpace="preserve"
    id="wallet-safew_svg__svg8"
    width={28}
    height={28}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="wallet-safew_svg__g6"
      transform="matrix(.02857 0 0 .03265 -.286 -2.325)"
      style={{
        fill: '#333',
      }}
    >
      <path
        d="M928.3 500V380.4c0-68.2-55.1-124.1-123-125.3v-60.6c0-67.8-56.4-123.3-125.4-123.3H135.4C66.4 71.2 10 126.6 10 194.4v609c0 68.9 56.4 125.4 125.4 125.4H803c68.9 0 125.4-56.4 125.4-125.4V683.5c34-.5 61.7-28.5 61.7-62.7v-58.3c-.1-34-27.8-62-61.8-62.5zm-1 120.8-.1.1H746.1l-.1-.1v-58l.1-.1h181.1l.1.1zM90.8 152.1c12-11.8 27.8-18.2 44.6-18.2h544.4c16.8 0 32.7 6.5 44.6 18.2 11.7 11.5 18.1 26.5 18.1 42.4V255H135.4c-16.8 0-32.7-6.5-44.6-18.2-11.7-11.5-18.1-26.5-18.1-42.4 0-15.8 6.4-30.9 18.1-42.3zm756.4 695.6c-11.9 11.9-27.6 18.5-44.2 18.5H135.4c-16.6 0-32.3-6.6-44.2-18.5-11.9-11.9-18.5-27.6-18.5-44.2V301.1c18.5 10.6 39.9 16.6 62.7 16.6H803c16.6 0 32.3 6.6 44.2 18.5 11.9 11.9 18.5 27.6 18.5 44.2V500H746c-34.5 0-62.7 28.2-62.7 62.7V621c0 34.5 28.2 62.7 62.7 62.7h119.7v119.9c-.1 16.5-6.6 32.2-18.5 44.1z"
        id="wallet-safew_svg__path4"
        style={{
          fill: '#333',
        }}
      />
    </g>
    <style type="text/css" id="style829">
      {'.wallet-safew_svg__st0{fillRule:evenodd;clipRule:evenodd}'}
    </style>
    <g
      id="wallet-safew_svg__main"
      transform="matrix(.27836 0 0 .27863 2.326 8.915)"
      style={{
        fill: '#333',
      }}
    >
      <g
        id="wallet-safew_svg__Group-16"
        transform="translate(-70 -35)"
        style={{
          fill: '#333',
        }}
      >
        <g
          transform="translate(70 34)"
          id="wallet-safew_svg__g838"
          style={{
            fill: '#333',
          }}
        >
          <g
            id="wallet-safew_svg__Group-15"
            transform="translate(0 .83)"
            style={{
              fill: '#333',
            }}
          >
            <path
              id="wallet-safew_svg__Fill-9"
              className="wallet-safew_svg__st0"
              d="m11.2 47.8 18.3 7.4 18.2-7.8L55 29.1l-7.8-18.2-18.3-7.3-18.2 7.8-7.3 18.3Zm18.3 10.8c-.2 0-.4 0-.6-.1L9.3 50.6c-.4-.2-.7-.5-.9-.9L.1 30.3c-.2-.4-.2-.8 0-1.3L8 9.5c.2-.4.5-.7.9-.9L28.3.3c.4-.2.8-.2 1.3 0l19.6 7.9c.3.1.6.4.8.8l8.3 19.4c.2.4.2.8 0 1.3l-7.9 19.6c-.2.4-.5.7-.9.9l-19.4 8.3c-.1.1-.4.1-.6.1z"
              style={{
                fill: '#333',
              }}
            />
            <path
              id="wallet-safew_svg__Fill-10"
              className="wallet-safew_svg__st0"
              style={{
                fill: '#333',
              }}
              d="M28.3 29.1 20.5 21v-3.7H38V21H25.8l7.6 8.1-7.8 8.6H38v3.8H20.5v-3.8z"
            />
          </g>
        </g>
      </g>
    </g>
    <path
      style={{
        fill: '#faa',
        strokeWidth: 0.0343388,
      }}
      d="M3.172 25.878c-.452-.126-.898-.517-1.124-.985-.264-.551-.245.148-.245-9.08 0-4.545.011-8.259.025-8.252.015.006.123.062.24.123.253.132.492.223.8.307.209.056.819.061 10.18.078l9.958.018.196.08c.43.173.798.535 1.013.996.208.446.216.544.216 2.79v2.024h-1.767c-1.157 0-1.83.013-1.948.038-.707.147-1.314.813-1.453 1.593-.069.387-.069 2.394 0 2.781.139.78.746 1.446 1.453 1.594.119.025.791.038 1.948.038h1.767v2.023c0 2.297-.006 2.367-.243 2.848-.193.39-.498.7-.871.884l-.273.134-9.857.006c-7.896.004-9.888-.003-10.015-.038zm10.23-1.844c1.504-.644 2.763-1.19 2.797-1.21a.507.507 0 0 0 .127-.142c.128-.21 2.276-5.598 2.278-5.718.003-.14-2.341-5.655-2.443-5.747-.083-.075-5.586-2.293-5.74-2.313-.1-.014-.57.176-2.901 1.173-1.94.83-2.81 1.218-2.873 1.283-.124.125-2.344 5.6-2.343 5.776.001.08.393 1.035 1.162 2.833.638 1.492 1.188 2.76 1.223 2.816a.537.537 0 0 0 .142.152c.044.027 1.315.548 2.826 1.158 1.91.77 2.787 1.11 2.879 1.11.098 0 .83-.299 2.866-1.17z"
      id="wallet-safew_svg__path1212"
    />
    <path
      style={{
        fill: '#faa',
        strokeWidth: 0.0343388,
      }}
      d="M21.032 16.999v-.928h5.15v1.855h-5.15z"
      id="wallet-safew_svg__path1251"
    />
    <path
      style={{
        fill: '#faa',
        strokeWidth: 0.0343388,
      }}
      d="M3.173 5.926c-.558-.154-1.083-.684-1.267-1.28-.342-1.107.313-2.328 1.366-2.548.246-.05 15.88-.054 16.15-.003.435.083.857.372 1.123.77.322.482.327.512.341 1.9l.012 1.21-8.784-.003c-6.971-.002-8.816-.012-8.94-.046Z"
      id="wallet-safew_svg__path1290"
    />
    <path
      style={{
        fill: '#fff',
        strokeWidth: 0.0344216,
      }}
      d="M8.003 23.2c-1.39-.563-2.541-1.045-2.556-1.07-.015-.026-.505-1.158-1.09-2.516l-1.062-2.47 1.012-2.542 1.012-2.542 2.503-1.073c1.377-.59 2.535-1.072 2.573-1.07.038.002 1.191.455 2.563 1.007l2.495 1.004 1.081 2.524 1.082 2.524-1.012 2.539-1.012 2.54-2.512 1.078-2.53 1.085c-.01.004-1.156-.454-2.547-1.017zm4.922-3.303v-.55l-1.702-.01-1.7-.008.654-.723 1.066-1.178.411-.455-1.053-1.12-1.053-1.12h3.377V13.666H8.003v1.052l1.086 1.128 1.087 1.128-.24.265-1.085 1.195-.845.93-.002.541-.001.543H12.925z"
      id="wallet-safew_svg__path1535"
    />
    <path
      style={{
        fill: '#fff',
        strokeWidth: 0.0344216,
      }}
      d="M8.003 23.201c-2.082-.842-2.537-1.038-2.571-1.105-.022-.045-.513-1.178-1.09-2.517l-1.049-2.436 1.013-2.542 1.013-2.543 2.503-1.072c1.377-.59 2.526-1.072 2.553-1.072.056 0 4.99 1.957 5.05 2.003.02.016.523 1.162 1.114 2.545l1.076 2.517-.69 1.731c-.381.952-.836 2.096-1.012 2.54l-.319.81-2.514 1.075-2.53 1.083c-.01.004-1.156-.453-2.547-1.017zm4.922-3.304v-.55l-1.703-.01-1.702-.008.437-.485 1.066-1.177.63-.692-1.045-1.112-1.045-1.113 1.681-.008 1.68-.01v-1.066H8.004v1.05l1.087 1.128 1.088 1.129-.224.248c-.122.137-.61.675-1.085 1.196l-.863.946-.002.542-.001.543H12.925z"
      id="wallet-safew_svg__path1574"
    />
  </svg>
);

export default SvgWalletSafew;
